import { Injectable } from '@angular/core';

export enum DeviceOrientation {
  Portrait = 0,
  Landscape = 1,
}

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor() {}

  public isTabletScreen(orientation?: DeviceOrientation) {
    let width = window.innerWidth;
    switch (orientation) {
      case DeviceOrientation.Portrait:
        return width <= 768 && width > 640;
      case DeviceOrientation.Landscape:
        return width <= 1024 && width > 640;
      default:
        return width <= 1024 && width > 640;
    }
  }

  public isDesktopScreen() {
    return window.innerWidth > 1024;
  }

  public isMobileScreen(orientation?: DeviceOrientation) {
    let width = window.innerWidth;
    switch (orientation) {
      case DeviceOrientation.Portrait:
        return width < 640;
      case DeviceOrientation.Landscape:
        return width <= 768 && width > 640;
      default:
        return width < 768;
    }
  }
}
